const isAuthenticated = (state) => {
  return !!state.accessToken
}

const user = (state) => {
  return state.user
}

const getPlace = (state) => {
  return state.place
}

const getRules = (state) => {
  return state.roles
}

const params = (state) => {
  return state.params
}

const accessToken = (state) => {
  return state.accessToken
}

const getUserDetails = (state) => {
  return state.userDetails
}

export default {
  isAuthenticated,
  user,
  getPlace,
  getRules,
  params,
  accessToken,
  getUserDetails,
}
